import { apiV1 } from "./api"

function getIngredients() {
  return apiV1("ingredients")
}

export { getIngredients }
